import { RowList, RowListRow } from '@/console/ui/RowList'
import { Button } from '@/console/ui/Button'
import { Note } from '@/console/ui/Note'
import { Callout } from '@/console/ui/Callout'
import { HeldWorkflowRow } from './holdRows'

/** 시안 `#s-disp-6` 우측(멈춰 있는 워크플로) 이식. */
export type HeldWorkflowListProps = {
  rows: HeldWorkflowRow[]
  onWakeAll: () => void
  /** 다른 조치가 진행 중이면 잠근다(PR 리뷰 — 눌러도 조용히 버려지던 문제). */
  disabled?: boolean
  /** 응답에 `nextPageToken` 이 남아 있는지 — 화면이 1페이지(200건)만 그리므로 잘렸음을 알린다. */
  hasMore?: boolean
}

export const HeldWorkflowList = ({ rows, onWakeAll, hasMore = false, disabled = false }: HeldWorkflowListProps): JSX.Element => {
  const listRows: RowListRow[] = rows.map((row) => ({
    key: row.key,
    name: row.label,
    mono: true,
    desc: row.typeLabel,
    right: <span style={{ fontFamily: 'var(--mono)', fontSize: 13 }}>{row.elapsed}</span>,
  }))

  return (
    <>
      <RowList rows={listRows} />
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', marginTop: 14 }}>
        <Button size="sm" disabled={disabled} onClick={onWakeAll}>
          전부 깨우기
        </Button>
        <span style={{ fontSize: 12.5, color: 'var(--ink-3)' }}>POST /holds/recheck · 규칙 존중 재평가</span>
      </div>
      {hasMore ? (
        <Callout tone="warn">200건까지만 보여요 — 서버에 다음 페이지가 더 있어요. 지금 화면의 목록이 전부가 아니니 건수로 판단하지 마세요.</Callout>
      ) : null}
      {/* PR 리뷰 Medium — 예전 문구는 "정책 Hold 만 나와요" 였는데 실제로는 거르지 않고 응답을
          그대로 보여준다(workflowType 필터는 아직 없다). 화면이 하지 않는 일을 한다고 말하면
          온콜 담당자가 목록을 잘못 읽는다. */}
      <Note>`GET /holds/subscribers` 응답을 거르지 않고 그대로 보여줘요. ?domain= 은 500 이라 안 보내고, workflowType 필터는 아직 없어요.</Note>
    </>
  )
}
